import React, { useContext } from 'react';
import { FormDataContext } from 'globalState/FormDataContext';
import dompurify from 'dompurify';

import Table from 'components/shared/Table/Table';
import GetMap from 'components/shared/Map/Map';

import StaffConsent from './Terms';
import ConsentForm from '../StepConsentForm';

const { sanitize } = dompurify;

function StepSummarySection() {
  const [formDataState, formDataDispatch] = useContext(FormDataContext);
  const {
    Firstname,
    LastName,
    PublicGeneralEnquiry,
    Email,
    PhoneNumber,
    DateOfIncident,
    DateOfIncidentFrom,
    TimeOfIncident,
    TimeOfIncidentFrom,
    TimeOfIncidentFromAmPm,
    TimeOfIncidentToAmPm,
    TransportMode,
    BusServiceNumber,
    TravelDirection,
    Town,
    RoadName,
    IncidentType,
    IncidentDetails,
    OffenderImages,
    PhotoName,
    CCTVControlRoom,
    Bodycam,
    ApproachGroup,
    AskGroupSupport,
    SafeguardingReferrals,
    GetConsent,
    ReportToPolice,
    TrainRoute,
    RailStation,
    TramDirection,
    TramStop,
    PhotoBase64,
    address,
    postcode,
    LockerNumber,
    BodycamLogNumber,
    ReferralType,
    WhatSupport,
    CrimeReference,
    LocationDetails,
    ViewMap,
  } = formDataState.formData;

  // convert time to 24hr time
  const timeFrom = `${formDataState.formData.TimeOfIncidentFrom} ${formDataState.formData.TimeOfIncidentFromAmPm}`;
  const timeTo = `${formDataState.formData.TimeOfIncidentTo} ${formDataState.formData.TimeOfIncidentToAmPm}`;

  function convertTo24HourFormat(timeString) {
    const [time, period] = timeString.split(' ');
    const [hour, minute] = time.split(':');
    let formattedHour = parseInt(hour, 10);

    if (period === 'PM') {
      formattedHour += 12;
    }

    // add another 0 if hour is less than 10
    function hoursWithZeros(dt) {
      if (dt > '10') {
        return `0${dt}`;
      }
      return dt;
    }

    // add another 0 if minute is 0
    function minutesWithLeadingZeros(dt) {
      if (dt === '0') {
        return '00';
      }
      return dt;
    }

    const min = minutesWithLeadingZeros(minute);
    const hr = hoursWithZeros(hour);

    return `${hr}:${min}`;
  }

  const formattedFromTime = convertTo24HourFormat(timeFrom);
  const formattedToTime = convertTo24HourFormat(timeTo);

  // get date am/pm
  const fromAmPm = TimeOfIncidentFromAmPm.toLowerCase();
  const toAmPm = TimeOfIncidentToAmPm.toLowerCase();

  const setStepInContext = (st) => {
    formDataDispatch({
      type: 'UPDATE_STEP',
      payload: st,
    });
  };

  const getCoords = (value) => {
    if (value) {
      const coords = value.split('place/')[1].split(',');
      return coords;
    }
    return []; // Or handle the case where value is undefined in your preferred way
  };

  const title = 'Check your answers';

  const dataLine1 = [];
  if (PublicGeneralEnquiry) {
    dataLine1.push(<span>{PublicGeneralEnquiry}</span>);
    dataLine1.push(
      <button
        type="button"
        className="ds-btn ds-btn--link ds-float-right"
        onClick={() => {
          setStepInContext(3);
        }}
      >
        Change
      </button>
    );
  }

  const dataLine2 = [];
  dataLine2.push(<span>Name</span>);
  dataLine2.push(<span>{`${Firstname} ${LastName}`}</span>);
  dataLine2.push(
    <button
      type="button"
      className="ds-btn ds-btn--link"
      onClick={() => {
        setStepInContext(2);
      }}
    >
      Change
    </button>
  );

  const dataLine3 = [];
  dataLine3.push(<span>Email</span>);
  dataLine3.push(<span>{`${Email} `}</span>);
  dataLine3.push(
    <button
      type="button"
      className="ds-btn ds-btn--link"
      onClick={() => {
        setStepInContext(3);
      }}
    >
      Change
    </button>
  );

  const dataLine4 = [];
  dataLine4.push(<span>Phone number</span>);
  dataLine4.push(<span>{`${PhoneNumber} `}</span>);
  dataLine4.push(
    <button
      type="button"
      className="ds-btn ds-btn--link"
      onClick={() => {
        setStepInContext(4);
      }}
    >
      Change
    </button>
  );

  const dataLine5 = [];
  dataLine5.push(<span>When did the incident happen?</span>);
  dataLine5.push(
    <span>{`${DateOfIncident} at ${formattedFromTime}${fromAmPm} to  ${formattedToTime}${toAmPm}`}</span>
  );
  dataLine5.push(
    <button
      type="button"
      className="ds-btn ds-btn--link"
      onClick={() => {
        setStepInContext(5);
      }}
    >
      Change
    </button>
  );

  const dataLine6 = [];
  dataLine6.push(<span>What mode of transport?</span>);
  dataLine6.push(<span>{`${TransportMode}`}</span>);
  dataLine6.push(
    <button
      type="button"
      className="ds-btn ds-btn--link"
      onClick={() => {
        setStepInContext(6);
      }}
    >
      Change
    </button>
  );
  const dataLine7 = [];

  if (TransportMode?.toLowerCase() === 'bus') {
    dataLine7.push(<span>Where did the incident happen?</span>);

    if (ViewMap === 'true') {
      dataLine7.push(
        <span>
          {/* {LocationDetails !== null && LocationDetails !== undefined && (
            <>
              <ul className="ds-bare-list">
                <div dangerouslySetInnerHTML={{ __html: sanitize(LocationDetails) }} />
              </ul>
            </>
          )} */}

          {postcode !== null && typeof postcode !== 'undefined' && (
            <>
              <GetMap lat={getCoords(LocationDetails)[1]} lang={getCoords(LocationDetails)[0]} />
            </>
          )}
        </span>
      );
    } else {
      dataLine7.push(
        <span>{`${BusServiceNumber}, ${TravelDirection}, ${Town}, ${RoadName}`}</span>
      );
    }
  } else if (TransportMode === 'Train') {
    dataLine7.push(<span>{`${TrainRoute}`}</span>);
  } else if (TransportMode === 'Tram') {
    dataLine7.push(<span>{`${TramDirection}`}</span>);
  }
  dataLine7.push(
    <button
      type="button"
      className="ds-btn ds-btn--link"
      onClick={() => {
        setStepInContext(7);
      }}
    >
      Change
    </button>
  );

  const dataLine8 = [];
  if (TransportMode?.toLowerCase() === 'train') {
    dataLine8.push(<span>Nearest Station</span>);
    dataLine8.push(<span>{`${RailStation}`}</span>);
    dataLine8.push(
      <button
        type="button"
        className="ds-btn ds-btn--link"
        onClick={() => {
          setStepInContext(7);
        }}
      >
        Change
      </button>
    );
  }
  const dataLine9 = [];
  if (TransportMode?.toLowerCase() === 'tram') {
    dataLine9.push(<span>Nearest Station</span>);
    dataLine9.push(<span>{`${TramStop}`}</span>);
    dataLine9.push(
      <button
        type="button"
        className="ds-btn ds-btn--link"
        onClick={() => {
          setStepInContext(7);
        }}
      >
        Change
      </button>
    );
  }

  const dataLine10 = [];
  dataLine10.push(<span>Type of incident</span>);
  dataLine10.push(<span>{`${IncidentType}`}</span>);
  dataLine10.push(
    <button
      type="button"
      className="ds-btn ds-btn--link"
      onClick={() => {
        setStepInContext(8);
      }}
    >
      Change
    </button>
  );

  const dataLine11 = [];
  dataLine11.push(<span>Incident description</span>);
  dataLine11.push(<span>{`${IncidentDetails}`}</span>);
  dataLine11.push(
    <button
      type="button"
      className="ds-btn ds-btn--link"
      onClick={() => {
        setStepInContext(9);
      }}
    >
      Change
    </button>
  );

  const dataLine12 = [];
  dataLine12.push(<span>Do you have a photo of the offender?</span>);
  let yesno = 'No';
  if (OffenderImages && OffenderImages.toLowerCase() === 'yes') {
    yesno = 'Yes';
  }
  dataLine12.push(<span>{`${yesno}`}</span>);
  dataLine12.push(
    <button
      type="button"
      className="ds-btn ds-btn--link"
      onClick={() => {
        setStepInContext(10);
      }}
    >
      Change
    </button>
  );

  // photo of the offender
  // const dataLine13 = [];
  // if (OffenderImages && OffenderImages.toLowerCase() === 'yes') {
  //   dataLine13.push(<span>Photo of the offender</span>);
  //   dataLine13.push(
  //     <span key="image-span">
  //       {PhotoName}
  //       <br />
  //       <img src={`data:image/png;base64,${PhotoBase64}`} alt={PhotoBase64} key="image" />
  //     </span>
  //   );
  //   dataLine13.push(
  //     <button
  //       type="button"
  //       className="ds-btn ds-btn--link"
  //       onClick={() => {
  //         setStepInContext(11);
  //       }}
  //     >
  //       Change
  //     </button>
  //   );
  // }

  // CCTV control room
  const dataLine14 = [];
  dataLine14.push(<span>Did you contact he CCTV control room to monitor he incident?</span>);
  yesno = 'No';
  if (CCTVControlRoom === 'Yes') {
    yesno = 'Yes';
  }
  dataLine14.push(
    <div>
      <span>{`${yesno}`}</span>
      <br />
      <span>{`${LockerNumber}`}</span>
    </div>
  );
  dataLine14.push(
    <button
      type="button"
      className="ds-btn ds-btn--link"
      onClick={() => {
        setStepInContext(11);
      }}
    >
      Change
    </button>
  );

  // bodycam
  const dataLine15 = [];
  dataLine15.push(<span>Did you turn on your bodycam?</span>);
  yesno = 'No';
  if (Bodycam === 'Yes') {
    yesno = 'Yes';
  }
  dataLine15.push(
    <div>
      <span>
        {`${yesno}`} <br />
        <span>{`${BodycamLogNumber}`}</span>
      </span>
    </div>
  );
  dataLine15.push(
    <button
      type="button"
      className="ds-btn ds-btn--link"
      onClick={() => {
        setStepInContext(12);
      }}
    >
      Change
    </button>
  );

  // did you approach politely
  const dataLine16 = [];
  dataLine16.push(<span>Did you approach the person or group and engage politely?</span>);
  yesno = 'No';
  if (ApproachGroup === 'Yes') {
    yesno = 'Yes';
  }
  dataLine16.push(<span>{`${yesno}`}</span>);
  dataLine16.push(
    <button
      type="button"
      className="ds-btn ds-btn--link"
      onClick={() => {
        setStepInContext(13);
      }}
    >
      Change
    </button>
  );

  // help and support
  const dataLine17 = [];
  dataLine17.push(<span>Did you ask the person or group if then needed help or support?</span>);
  yesno = 'No';
  if (AskGroupSupport === 'Yes') {
    yesno = 'Yes';
  }
  dataLine17.push(
    <div>
      <span>{`${yesno}`}</span>
      <br />
      <span>{`${WhatSupport}`}</span>
    </div>
  );
  dataLine17.push(
    <button
      type="button"
      className="ds-btn ds-btn--link"
      onClick={() => {
        setStepInContext(14);
      }}
    >
      Change
    </button>
  );

  // Safeguarding policy
  const dataLine18 = [];
  dataLine18.push(
    <span>
      In line with the TfWM Safeguarding Policy, did you put in any safeguarding/vulnerability
      referrals to your line manager?
    </span>
  );
  yesno = 'No';
  if (SafeguardingReferrals === 'Yes') {
    yesno = 'Yes';
  }
  if (SafeguardingReferrals === 'NA') {
    yesno = 'Not applicable';
  }
  dataLine18.push(
    <div>
      <span>{`${yesno}`}</span>
      <br />
      <span>{`${ReferralType}`}</span>
    </div>
  );
  dataLine18.push(
    <button
      type="button"
      className="ds-btn ds-btn--link"
      onClick={() => {
        setStepInContext(15);
      }}
    >
      Change
    </button>
  );
  // consent
  const dataLine19 = [];
  dataLine19.push(<span>Did you get consent?</span>);
  yesno = 'No';
  if (GetConsent === 'Yes') {
    yesno = 'Yes';
  }
  dataLine19.push(<span>{`${yesno}`}</span>);
  dataLine19.push(
    <button
      type="button"
      className="ds-btn ds-btn--link"
      onClick={() => {
        setStepInContext(16);
      }}
    >
      Change
    </button>
  );

  // report to police
  const dataLine20 = [];
  dataLine20.push(
    <span>
      If the person or group refused to leave the bus station, or the problem escalated, did you
      report the incident to the police?
    </span>
  );
  yesno = 'No';
  if (ReportToPolice === 'Yes') {
    yesno = 'Yes';
  }
  dataLine20.push(
    <div>
      <span>{`${yesno}`}</span>
      <br />
      <span>{`${CrimeReference}`}</span>
    </div>
  );
  dataLine20.push(
    <button
      type="button"
      className="ds-btn ds-btn--link"
      onClick={() => {
        setStepInContext(17);
      }}
    >
      Change
    </button>
  );

  /* End of Table Data */

  const data = [dataLine2, dataLine3, dataLine4];
  const incident = [
    dataLine5,
    dataLine6,
    dataLine7,
    dataLine8,
    dataLine9,
    dataLine10,
    dataLine11,
    dataLine12,
    // dataLine13,
  ];
  const yourResponse = [
    dataLine14,
    dataLine15,
    dataLine16,
    dataLine17,
    dataLine18,
    dataLine19,
    dataLine20,
  ];

  return (
    <>
      <div className="ds-col-1">
        <h2 className="ds-fe-question ds-m-t-none">{title}</h2>

        <Table
          title="About you"
          classes=""
          cellClasses={['', '', 'ds-text-align-right ds-p-r-none']}
          headers={[]}
          values={data}
          data-private
        />

        <Table
          title="About the incident"
          classes=""
          cellClasses={['', '', 'ds-text-align-right ds-p-r-none']}
          headers={[]}
          values={incident}
          data-private
        />

        <Table
          title="Your response"
          classes=""
          cellClasses={['', '', 'ds-text-align-right ds-p-r-none']}
          headers={[]}
          values={yourResponse}
          data-private
        />

        <h3>Now send your report</h3>
        <p>
          By submitting this report you are confirming that, to the best of your knowledge, the
          details you are providing are correct.
        </p>
        <StaffConsent />
        <ConsentForm />
      </div>
    </>
  );
}

export default StepSummarySection;
